// extracted by mini-css-extract-plugin
export default {"root":"usbBFvK1yJzFUwvvkoV2","th":"lOGKeaIo9LPlq4RCUqnK","thContent":"LiS50eKWgml9kaSvohTM","placeHolderShimmer":"KUgZG8ip7mBnqcUFrUzQ"};